import { render, staticRenderFns } from "./modal_add.vue?vue&type=template&id=8fe2852a&scoped=true&"
import script from "./modal_add.vue?vue&type=script&lang=js&"
export * from "./modal_add.vue?vue&type=script&lang=js&"
import style0 from "./modal_add.vue?vue&type=style&index=0&id=8fe2852a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe2852a",
  null
  
)

export default component.exports